import { render, staticRenderFns } from "./BackToTextPrepPrompt.vue?vue&type=template&id=66eb1744&"
import script from "./BackToTextPrepPrompt.vue?vue&type=script&lang=js&"
export * from "./BackToTextPrepPrompt.vue?vue&type=script&lang=js&"
import style0 from "./BackToTextPrepPrompt.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../abbreviation/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports